import axios from "axios";
import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        taxCode: [],
    },
    actions: {
        async getTaxCode(ctx) {
            return axios.get(`/api/v1/stripe/tax/codes`).then(result => {
                if (result.data) {
                    ctx.commit('setTaxCode', result.data);
                }
                return result.data;
            });
        },
        async getAccountTaxSettings(ctx, { stripeAccountId }) {
            return axios.get(`/api/v1/stripe/tax/${stripeAccountId}/settings`).then(result => {
                return result.data;
            });
        },
        async updateTaxSettings(ctx, { stripeAccountId, taxSettings }) {
            return axios.put(`/api/v1/stripe/tax/${stripeAccountId}/settings`, { ...taxSettings });
        },
        async getTaxRegistration(ctx, { stripeAccountId }) {
            return axios.get(`/api/v1/stripe/tax/${stripeAccountId}/registration`).then(result => {
                return result.data;
            });
        },
    },
    getters: {
        getTaxCode(state) {
            return state.taxCode;
        },
    },
    mutations: {
        setTaxCode(state, payload) {
            state.taxCode = payload;
        },
    }
};
